import { IImage } from 'interfaces';

type Props = {
  image: IImage;
  classNames?: string;
  maxHeight?: number;
};

const CoverImage = ({ image, classNames, maxHeight }: Props): React.ReactElement => {
  let { height, width } = image;
  const { src, alt } = image;

  if (!height || !width) {
    return <img className={classNames} alt={alt || ''} width="100%" height="100%" src={src} />;
  }

  if (maxHeight && height > maxHeight) {
    // need to recalc dimensions
    width *= maxHeight / height;
    height = maxHeight;
  }

  const cleanSrc = src.replace(/\?.*$/, '');
  const srcScaledDown = height ? `${cleanSrc}?h=${height}` : `${cleanSrc}?w=${width}`;
  const srcSet = [`${srcScaledDown} 1x`, height ? `${cleanSrc}?h=${height * 2} 2x` : `${cleanSrc}?w=${width * 2} 2x`];

  return (
    <img
      className={classNames}
      alt={alt || ''}
      width={width || '100%'}
      height={height || '100%'}
      src={srcScaledDown}
      srcSet={srcSet.join(',')}
    />
  );
};

CoverImage.defaultProps = {
  classNames: '',
  maxHeight: undefined,
};

export default CoverImage;
